module.exports = __webpack_public_path__ + "img/cadenza_marcato_brown1.5bfba08a.jpg";